import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import "./TableOrderPage.css";

export default function TableOrderPage() {
  const { slug, tableNumber } = useParams();
  const [session, setSession] = useState(null);
  const [menu, setMenu] = useState({ categories: [], items: [] });
  const [cart, setCart] = useState([]);

  useEffect(() => {
    document.title = `Table ${tableNumber} — Order Now`;
    (async () => {
      try {
        // Open a fresh session.
        const { data: sess } = await api.post(`/t/${slug}/${tableNumber}/session`);
        setSession(sess);
        // Pull public menu.
        const { data: menuData } = await api.get(`/public/menu`, { params: { biz: slug } });
        setMenu(menuData || { categories: [], items: [] });
      } catch (e) {
        toast.error("Couldn't open table session. Wave at staff.");
      }
    })();
  }, [slug, tableNumber]);

  const subtotal = cart.reduce((s, c) => s + c.price * c.qty, 0);

  function addToCart(item) {
    setCart((c) => {
      const ex = c.find((x) => x.menu_item_id === item.id);
      if (ex) return c.map((x) => x.menu_item_id === item.id ? { ...x, qty: x.qty + 1 } : x);
      return [...c, { menu_item_id: item.id, name: item.name, price: item.price, qty: 1 }];
    });
    toast.success(`Added ${item.name}`);
  }

  async function send() {
    if (!session || cart.length === 0) return;
    try {
      await api.post("/t/order", { session_id: session.id, items: cart });
      toast.success("Sent to kitchen!");
      setCart([]);
    } catch (e) {
      toast.error("Couldn't send. Try again.");
    }
  }

  const byCat = {};
  (menu.items || []).forEach((it) => {
    const cid = it.category_id || "_";
    byCat[cid] = byCat[cid] || [];
    byCat[cid].push(it);
  });

  return (
    <div className="tq-root" data-testid="table-order-page">
      <header className="tq-header">
        <h1>Table {tableNumber}</h1>
        <p>Order what you like, when you like. Goes straight to the kitchen.</p>
      </header>
      {(menu.categories || []).map((c) => (
        <section key={c.id} className="tq-section" data-testid={`tq-cat-${c.id}`}>
          <h2 className="tq-cat-title">{c.name}</h2>
          {(byCat[c.id] || []).map((it) => (
            <div key={it.id} className="tq-item" data-testid={`tq-item-${it.id}`}>
              <div className="tq-item__body">
                <div className="tq-item__name">{it.name}</div>
                {it.description && <div className="tq-item__desc">{it.description}</div>}
                <div className="tq-item__price">${it.price}</div>
              </div>
              <button className="tq-add" onClick={() => addToCart(it)} data-testid={`tq-add-${it.id}`}>Add</button>
            </div>
          ))}
        </section>
      ))}
      {cart.length > 0 && (
        <div className="tq-cart" data-testid="tq-cart">
          <div>
            <div style={{ fontSize: 12, opacity: 0.7 }}>{cart.length} items in cart</div>
            <strong>${subtotal.toFixed(2)}</strong>
          </div>
          <button onClick={send} data-testid="tq-send">Send to kitchen</button>
        </div>
      )}
    </div>
  );
}
